<router-outlet>
    <!-- Faq -->
    <!-- <pme-floating-faq></pme-floating-faq> -->
</router-outlet>

<pme-snack-bar></pme-snack-bar>
